import React, { useContext, useEffect } from "react";
import { useMutation } from "react-apollo";
import { TextContainer } from "@shopify/polaris";

// import helper components
import { Spinner } from "lib/components";

// import helper
import baseHelper from "lib/helpers/base";

// import context
import { PrivateContext } from "lib/context";

// import constant
import constant from "lib/constant/constant";

// import hoc
import { withErrorBoundary } from "lib/hoc";

import { errorHelper } from "lib/helpers";

// import gql
import { CONNECT_PAYPAL_VENDOR } from "app/setup/apollo/mutations";

const PaypalCallback = () => {
  const [connectToPaypal, { loading }] = useMutation(CONNECT_PAYPAL_VENDOR);
  const { gql } = constant;
  const { currentUser, currentUserRefetch = () => {}, history, isLoading, cms } = useContext(PrivateContext);
  const { _id: id } = currentUser;
  const { code, state } = baseHelper.getQueryParams(history.location.search);

  const connectPaypal = async () => {
    try {
      const response = await connectToPaypal({ variables: { input: { code } } });

      const responseData = baseHelper.getResponseData(response.data, gql.CONNECT_PAYPAL_VENDOR);
      const responseError = baseHelper.getResponseError(response.data, gql.CONNECT_PAYPAL_VENDOR);

      if (responseError) {
        history.push("/payment-connect", { isPaypalConnected: false, message: responseError });
      }

      if (responseData) {
        currentUserRefetch();
        history.push("/payment-connect", {
          isPaypalConnected: true,
        });
      }
    } catch (exception) {
      history.push("/payment-connect", { isPaypalConnected: false, message: errorHelper.parse(exception) });
    }
  };

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (code) {
      connectPaypal();
    } else {
      history.push("/payment-connect");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, code, history]);

  if (isLoading || loading) {
    return <Spinner fontSize={42} />;
  }

  if (id !== state) {
    return <TextContainer>{cms("common.message.error.notFound")}</TextContainer>;
  }

  return null;
};

export default withErrorBoundary(PaypalCallback);
